var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('transition-group',{attrs:{"name":"fade","tag":"div"}},[_c('img',{key:"1",attrs:{"src":require("@/assets/logo.png"),"alt":"logo"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCollapse),expression:"!isCollapse"}],key:"2",staticClass:"text"},[_vm._v("友虹文档中台")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }